import React from "react";

function Loader() {
  return (
    <div className="load-container">
      <div className="spans">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  );
}

export default Loader;
